<template>
  <div class="l-grid-item">
    <ul class="site-map">
      <li class="site-map-item">
        <a :href="irTop[0].path">
          <span class="site-map-text">IR情報</span>
        </a>
        <ul class="site-map-child">
          <li class="site-map-item" v-for="menu in irMenus" :key="menu.path">
            <a :href="menu.path">
              <span class="site-map-underline">{{ menu.name }}</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import Menus from "@/mixins/irMenus.js";

export default {
  mixins: [Menus],
};
</script>
